import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from "../../../../dataGrid/columnFilters";

export default class GridConfig {
  constructor(configuration, fileType) {
    this.name = "GridConfiguration";
    this.config = GridConfig.getDefaultConfiguration(fileType);
  }
  static getHeaderDetails = (fileType) => {
    console.log("FILE HEADER", fileType);
    switch (fileType) {
      case "trailer":
        return {
          headerName: "Equipment Number",
          headerTooltip: "Equipment Number",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
      case "wave":
        return {
          headerName: "Wave Number",
          headerTooltip: "Wave Number",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
      case "anchor":
        return {
          headerName: "Anchor Point Name",
          headerTooltip: "Anchor Point Name",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
      case "driver":
        return {
          headerName: "Driver ID",
          headerTooltip: "Driver ID",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
      case "customerSplInst":
        return {
          headerName: "Customer ID",
          headerTooltip: "Customer ID",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
      default:
        return {
          headerName: "Product ID",
          headerTooltip: "Product ID",
          field: "id",
          minWidth: 200,
          maxWidth: 200,
        };
    }
  };

  static getDefaultConfiguration(fileType) {
    return {
      title: appConstants.gridNames.TerminalAcces,
      keyColumn: "productId",
      enableFilters: true,
      enableSorting: false,
      rowSelection: "single",
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        filterFramework: MultiSelectFilter,
      },
      columns: [
        GridConfig.getHeaderDetails(fileType),
        {
          headerName: "Error",
          headerTooltip: "Error Description",
          field: "error",
          minWidth: 400,
          maxWidth: 500,
        },
      ],
    };
  }
}
